import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../store"

interface PendingRequestState {
  requests: Array<string>
}

const initialState: PendingRequestState = {
  requests: [],
}

export const pendingRequestsSlice = createSlice({
  name: "pendingRequests",
  initialState,
  reducers: {
    setPendingRequests: (state, action: PayloadAction<string>) => {
      state.requests = [...state.requests, action.payload]
    },
    removePendingRequest: (state, action: PayloadAction<string>) => {
      state.requests = state.requests.filter(
        (request) => request !== action.payload,
      )
    },
  },
})

export const { setPendingRequests, removePendingRequest } =
  pendingRequestsSlice.actions
export const selectPendingRequests = (state: RootState) =>
  state.pendingRequests.requests
export default pendingRequestsSlice.reducer
